import React, { PureComponent } from 'react';
import { DLModal } from 'appSrc/components/Shards';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';
import { PrimaryButton } from 'appSrc/components/UI';
import DatePicker from 'react-datepicker';
import moment from 'moment-timezone';
import style from './styles/style.module.css';

import 'react-datepicker/dist/react-datepicker.css';


class PickScheduleModal extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            working: false,
            selectedDate: undefined,
        };
    }
    changeDate = ( date ) => {
        this.setState( { selectedDate: date } );
    }
    submitHandler = () => {
        var date = moment( this.state.selectedDate );
        this.props.onSubmit( date );
    }



    render() {
        const { selectedDate, working } = this.state;

        return (
            <DLModal title='Select Date' className={ style.dateModal }
            closeHandler={ this.props.closeHandler } visible={ this.props.visible }>
                <div className={ style.content }>
                    <br/>
                    <DatePicker className={ style.picker } inline
                    placeholderText="Click to select a date" includeDates={ this.props.include }
                    selected={ selectedDate } onChange={ this.changeDate } />
                    <PrimaryButton label='Add' onClick={ this.submitHandler } />
                </div>
                { working &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }
}
PickScheduleModal.defaultProps = {
    onSubmit: () => {},
};

export default PickScheduleModal;
